var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17878 9.0968H22.1788C22.7288 9.0968 23.1788 8.6468 23.1788 8.0968C23.1788 7.5468 22.7288 7.0968 22.1788 7.0968H8.17878C7.62878 7.0968 7.17878 7.5468 7.17878 8.0968C7.17878 8.6468 7.62878 9.0968 8.17878 9.0968ZM23.3388 10.8968C23.2488 10.4368 22.8388 10.0968 22.3588 10.0968H7.99878C7.51878 10.0968 7.10878 10.4368 7.01878 10.8968L6.01878 15.8968C5.89878 16.5168 6.36878 17.0968 6.99878 17.0968H7.17878V22.0968C7.17878 22.6468 7.62878 23.0968 8.17878 23.0968H16.1788C16.7288 23.0968 17.1788 22.6468 17.1788 22.0968V17.0968H21.1788V22.0968C21.1788 22.6468 21.6288 23.0968 22.1788 23.0968C22.7288 23.0968 23.1788 22.6468 23.1788 22.0968V17.0968H23.3588C23.9888 17.0968 24.4588 16.5168 24.3388 15.8968L23.3388 10.8968ZM15.1788 21.0968H9.17878V17.0968H15.1788V21.0968Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.31b775b449017c82cf2b33cc8795525a.svg";
export { ForwardRef as ReactComponent };